import React from "react";

const Modal = ({ title, children, onClose }) => {
  return (
    <div
      className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
      onClick={onClose}
    >
      <div
        className="relative w-auto max-w-lg mx-auto my-6"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        <div className="bg-white p-6 rounded-lg shadow-xl relative flex flex-col w-full">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">{title}</h2>
            <button
              onClick={onClose}
              className="text-gray-600 text-3xl font-semibold leading-none bg-transparent border-0 outline-none focus:outline-none"
            >
              &times;
            </button>
          </div>
          <div className="flex-grow">{children}</div>
          <div className="flex justify-end mt-4">
            <button
              onClick={onClose}
              className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
